import { Box, Typography } from "@mui/material";
import { DEMAND_METRICS_CONFIG } from "./constants";
import theme from "../../../../theme";

const RADIUS = theme.borderRadius.xxxl;

const getCardRadius = (index, length) => {
  if (index === 0) {
    // First card: bottom-left only
    return {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: RADIUS,
      borderBottomRightRadius: 0,
    };
  }
  if (index === length - 1) {
    // Last card: top-right only
    return {
      borderTopLeftRadius: 0,
      borderTopRightRadius: RADIUS,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    };
  }
  // Middle cards: no radius
  return { borderRadius: 0 };
};

export const DemandMetricsSection = ({ keyMetrics }) => (
  <Box>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "1fr 1fr",
          md: "repeat(4, 1fr)",
        },
        gap: 2,
      }}
    >
      {DEMAND_METRICS_CONFIG.map(({ key, label }, index) => (
        <Box
          key={key}
          sx={{
            p: 2.5,
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: "primary.brandSecondary",
            ...getCardRadius(index, DEMAND_METRICS_CONFIG.length),
          }}
        >
          <Typography
            variant="overline"
            sx={{
              color: "primary.brandSecondary",
              fontWeight: 700,
              letterSpacing: 0.5,
            }}
          >
            {label}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            {keyMetrics?.[key] ?? "No data available."}
          </Typography>
        </Box>
      ))}
    </Box>
  </Box>
);
